export const REF_QUERY_REG_EXP = /([$%@]){([0-9A-Za-z.-_]+)}/g;
